import Vue from 'vue'
import Vuex from 'vuex'
import inventory from './modules/inventory'
import darkMode from './modules/darkMode'
import auth from './modules/auth'
import general from './modules/general'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
      general,
    inventory,
    darkMode,
    auth
  }
})